/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryStockTransferDto as DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/inventory-stock-transfer-dto';

export interface CancelStockTransfer$Params {
  inventoryId: string;
  transferId: string;
}

export function cancelStockTransfer(http: HttpClient, rootUrl: string, params: CancelStockTransfer$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>> {
  const rb = new RequestBuilder(rootUrl, cancelStockTransfer.PATH, 'put');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.path('transferId', params.transferId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTransfersInventoryStockTransferDto>;
    })
  );
}

cancelStockTransfer.PATH = '/api/inventories/{inventoryId}/transfers/{transferId}/cancel';
